// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DDq3","field":"styles_field__1FCL3","fieldCol":"styles_fieldCol__3YzIF","diffCol":"styles_diffCol__3Vkr_","diff":"styles_diff__1tdsO"};